import React, { useEffect, useState, useContext, memo, useRef } from 'react';
import axios from 'axios';
import { ManagerAuthContext } from "../context/AuthManager";
import { ToastContainer, toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import moment from "jalali-moment";
import { jsPDF } from "jspdf";
import "jspdf-autotable";

const baseURL = process.env.REACT_APP_API_URL || 'https://clinic.salamatpayanew.ir';

export const ReportAll = () => {
  const { currentUserRF } = useContext(ManagerAuthContext);

  const [searchQuery, setSearchQuery] = useState("");
  const [mainList, setMainList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = async (query) => {
    setLoading(true);
    setError(null);
    try {
      const endpoint =
        query.match(/^\d{10}$/) // کد ملی
          ? `sicknesSperiodListRA`
          : query.match(/^\d{4}-\d{2}-\d{2}$/) // تاریخ
          ? `sicknesSperiodListTELRA`
          : `sicknesSperiodListNameRA`; // نام و نام خانوادگی

      const res = await fetch(`${baseURL}/Register/${endpoint}/${currentUserRF.nezam}&${query}`);
      if (!res.ok) throw new Error('خطا در دریافت اطلاعات');
      const data = await res.json();
      setMainList(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => {
    if (searchQuery.trim()) {
      fetchData(searchQuery);
    }
  };

  const handlePrint = () => {
    const doc = new jsPDF("fa", "mm", "a4");
    const tableColumn = ["ردیف", "نام سرویس", "مبلغ", "تاریخ مراجعه"];
    const tableRows = mainList.map((item, index) => [
      index + 1,
      item.name,
      Number(item.price).toLocaleString('fa-IR'),
      item.date,
    ]);

    const formattedDateTime = moment().locale("fa").format("YYYY/MM/DD - HH:mm:ss");
    const patientName = mainList.length > 0 ? mainList[0].nameserv : "نامشخص";

    doc.setFont("helvetica", "normal");
    doc.text(`گزارش بیمار: ${patientName}`, 105, 10, { align: "center" });
    doc.text(`تاریخ و ساعت: ${formattedDateTime}`, 105, 20, { align: "center" });

    doc.autoTable({
      startY: 30,
      head: [tableColumn],
      body: tableRows,
      styles: { font: "helvetica", fontSize: 10, halign: "center" },
      headStyles: { fillColor: [200, 200, 200] },
    });

    const totalPrice = mainList.reduce((sum, item) => sum + (Number(item.price) || 0), 0);
    doc.text(`جمع کل مبالغ: ${totalPrice.toLocaleString('fa-IR')} تومان`, 105, doc.lastAutoTable.finalY + 10, {
      align: "center",
    });

    doc.save("report.pdf");
  };

  const totalPrice = mainList.reduce((sum, item) => sum + (Number(item.price) || 0), 0);

  const formattedDateTime = moment().locale("fa").format("YYYY/MM/DD - HH:mm:ss");
  const patientName = mainList.length > 0 ? mainList[0].nameserv : "نامشخص";

  return (
    <div style={{ fontFamily: 'Tahoma, sans-serif', backgroundColor: '#f9f9f9', padding: '20px' }}>
      <section className="content" dir="rtl">
        <h3 style={{ color: '#333', textAlign: 'center', marginBottom: '20px' }}>گزارش کلی</h3>
        <p style={{ textAlign: 'center', color: '#555', fontSize: '14px' }}>تاریخ و ساعت: {formattedDateTime}</p>
        {mainList.length > 0 && (
          <p style={{ textAlign: 'center', color: '#777', fontSize: '16px', fontWeight: 'bold' }}>
            نام بیمار: {patientName}
          </p>
        )}
        <div className="row" style={{ marginBottom: '20px', justifyContent: 'center' }}>
          <div className="form-group w-60" style={{ marginBottom: '10px', padding: '10px', maxWidth: '400px' }}>
            <input
              type="text"
              className="form-control"
              style={{ border: '1px solid #ccc', borderRadius: '5px', padding: '8px' }}
              placeholder="کد ملی، تاریخ (1400-01-01)، یا نام و نام خانوادگی"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <button
              className="btn btn-primary mt-2"
              style={{ marginTop: '10px', width: '100%' }}
              onClick={handleSearch}
            >
              جستجو
            </button>
            <button
              className="btn btn-secondary mt-2"
              style={{ marginTop: '10px', width: '100%' }}
              onClick={handlePrint}
            >
              پرینت گزارش
            </button>
          </div>
        </div>

        {loading && <p style={{ textAlign: 'center', color: '#007bff' }}>در حال بارگذاری...</p>}
        {error && <p className="text-danger" style={{ textAlign: 'center' }}>{error}</p>}

        {mainList.length > 0 ? (
          <div className="table-responsive">
            <table className="table bg-white custom-rounded" style={{ border: '1px solid #ddd', marginTop: '20px' }}>
              <thead style={{ backgroundColor: '#f1f1f1', color: '#333' }}>
                <tr className="text-center">
                  <th>ردیف</th>
                  <th>نام سرویس</th>
                  <th>مبلغ</th>
                  <th>تاریخ مراجعه</th>
                </tr>
              </thead>
              <tbody>
                {mainList.map((item, index) => (
                  <tr key={item.id} style={{ textAlign: 'center' }}>
                    <td>{index + 1}</td>
                    <td>{item.name}</td>
                    <td>{Number(item.price).toLocaleString('fa-IR')} تومان</td>
                    <td>{item.date}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="text-end p-3" style={{ textAlign: 'right', fontWeight: 'bold' }}>
              <strong>جمع کل مبالغ: </strong>
              {totalPrice.toLocaleString('fa-IR')} تومان
            </div>
          </div>
        ) : (
          !loading && <p style={{ textAlign: 'center', color: '#666' }}>داده‌ای برای نمایش وجود ندارد.</p>
        )}
      </section>
    </div>
  );
};
